import { Component, Input, OnInit, Output, EventEmitter, OnChanges, effect, signal } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import { FundingAccountsService }  from "../../services/funding-accounts.service";
import { SharedService }  from "../../services/shared.service";
import { SdkService }  from "../../services/sdk.service";
// import { EventEmitterService }  from "../../services/event-emitter.service";
import { IFundingAccount } from '../../interfaces/funding-account';
import { IFundingAccountsResponse } from '../../interfaces/funding-accounts-response';
import { IDisbursementSession } from 'src/app/interfaces/disbursement-session';
import { IBrandProfile } from 'src/app/interfaces/brand-profile';
import { IPageContent } from '../../interfaces/page-content';
import { ConfirmationDialogComponent } from '../../components/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-funding-accounts',
  templateUrl: './funding-accounts.component.html',
  styleUrls: ['./funding-accounts.component.css']
})
export class FundingAccountsComponent implements OnInit {

//  @Input() bFundingAccounts: boolean = false;
  @Input() dsbOccurrenceUuid!: string;

  varTest = signal('Basil');

//  @Output() addFundingAccount: EventEmitter<string> = new EventEmitter<string>();

  envRegion!: string;
  disbursementSession!: IDisbursementSession;
  brandProfile!: IBrandProfile;
  pageContent!: IPageContent;
  isLogoutVisible: boolean = true;

  // displayedColumns: string[] = ['fundingAccountNickname', 'institutionName', 'maskedFundingAccount', 'singleUse', 'actChoose', 'actDelete'];
  fundingAccountResponse?: IFundingAccountsResponse = undefined;
  fundingAccounts: IFundingAccount[] = [];
  selection = new SelectionModel<IFundingAccount>(true, []);

  dsbMessage?: string = "";

  achButtonLiteral: string = 'Add ACH';
  cardButtonLiteral: string = 'Add Card';

  setVarTest(): void {
    this.varTest.set(Date.now().toString());
  }

  public constructor(
    private router: Router,
    private dialog: MatDialog,
    private fundingAccountsService: FundingAccountsService,
    private sdkService: SdkService,
    private sharedService: SharedService
    ) {

      effect(() => {
        const logName = this.varTest();
        if(logName) {
            console.log('logName:', logName );
        }
    })

    }

  ngOnInit() {
    // Get the current enviromental region
    this.envRegion = this.sharedService.getEnvRegion();

    // Get the current brand profile
    this.brandProfile = this.sharedService.getBrandProfile();

    // Customize 'Add ACH' and 'Add Card' buttons, if needed
    this.achButtonLiteral = this.sharedService.getCustomizedLabels("ADD_ACH_BUTTON_LITERAL") || 'Add ACH';
    this.cardButtonLiteral = this.sharedService.getCustomizedLabels("ADD_CARD_BUTTON_LITERAL") || 'Add Card';

    // Make preparations for the page generic content
    this.pageContent = {
      headerTitle: this.sharedService.getCustomizedTitle('APP_TITLE') || '',
      headerSubtitle: this.sharedService.getCustomizedTitle('FUNDING_ACCOUNTS') || '',
      headerAvatar: 'business.png'
    }

    // Get the current disbursement session
    this.disbursementSession = this.sharedService.getDisbursementSession();
    this.dsbMessage = this.sharedService.getCustomizedPrompt("NO_FUNDING_ACCOUNT_EXISTS");

        // Load up the SDk script
        if (this.disbursementSession.billerId) {
          this.sdkService.loadJsSdkScript(this.disbursementSession.billerUuid);
        }     


    // List out all customer's existing fundding accounts
    this.getFundigAccounts();

  }

  getFundigAccounts() {

    if (this.disbursementSession && this.envRegion) {
      // let envRegion: string = 'qa';
      // let billerId: string = '555348';
      // let billingAccountNumber: string = '99901';

      this.fundingAccountsService.fetchFundingAccounts(this.envRegion, this.disbursementSession.sessionId)
      .subscribe({
        next: (response) => {
          this.fundingAccountResponse = response;
          if (this.fundingAccountResponse) {
            this.fundingAccounts = this.fundingAccountResponse.tokenList;
            this.fundingAccounts.sort((a, b) => (a.tokenid > b.tokenid) ? 1 : -1);
            this.fundingAccounts.slice(0, 3);
            // Add a column for the checkbox
            this.fundingAccounts.map((obj) => {
              obj.checked = false;
              return obj;
            })
            // Figure out the message for the customer depending on whether there is already at least one funding account
            if (this.fundingAccounts) {
              if (this.fundingAccounts.length > 0) {
                this.dsbMessage = this.sharedService.getCustomizedPrompt("FUNDING_ACCOUNTS_EXIST");
              }
            }
          }
        },
        error: (error) => {
        },
        complete: () => {
        }
      });
    }
  }

  onAddAch() {
    this.router.navigate(['/dsb-ach']);
  }

  onAddCard() {
    this.router.navigate(['/dsb-card']);
  }

  onDeleteFundingAccount(tokenId: string) {
    var fundingAccount = this.fundingAccounts.find(item => item.tokenid === tokenId);
    this.fundingAccounts
    const dialogRef = this.dialog.open(ConfirmationDialogComponent,{
      data:{
        title: this.sharedService.getCustomizedTitle('APP_TITLE'),
        message: "Do you really want to delete the funding account '" + fundingAccount?.maskedFundingAccount
          + "', so you won't be able to use it in the future?",
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.fundingAccountsService.deleteFundingAccount(this.envRegion, this.disbursementSession.sessionId, tokenId)
        .subscribe({
          next: (response) => {
            if (response) {
              if (response.status.includes("success")) {
                this.getFundigAccounts();
              }
            }
          },
          error: (error) => {
          },
          complete: () => {
          }
        });
      }
    });

  }

  // onChooseFundingAccount(tokenId: string) {
  //   if (tokenId) {
  //     // Emit the chosen funding account back to disbursement occurrences page
  //     // this.FundingAccountChosen.emit(this.fundingAccounts.find(element => element.tokenid == tokenId));
  //     // let fundingAccount: any = this.fundingAccounts.find(element => element.tokenid == tokenId);
  //     // let navigationExtras: NavigationExtras = {
  //     //   state: {
  //     //     fundingAccount: fundingAccount
  //     //   },
  //     // };
  //     // this.router.navigate(["/dsb-ocr"], navigationExtras);
  //     this.fundingAccountsService.linkFundingAccountToOccurrence(this.envRegion, this.disbursementSession.sessionId,
  //       tokenId, this.dsbOccurrenceUuid)
  //     .subscribe(
  //       (response) => {
  //         if (response) {
  //           this.router.navigate(["/dsb-ocr"]);
  //         }
  //       }
  //     )
  //   }
  // }

  // Whether the number of selected elements matches the total number of rows.
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    if (this.fundingAccounts) {
      const numRows = this.fundingAccounts.length;
      return numSelected === numRows;
    }
    return false;
  }

  // Selects all rows if they are not all selected; otherwise clear selection.
  masterToggle() {
    if (this.fundingAccounts) {
      this.isAllSelected() ?
      this.selection.clear() :
      this.fundingAccounts.forEach((row: IFundingAccount) => this.selection.select(row));
    }
  }

  deleteFundingAccountHandler(status: string) {
    let message: string = '';
    if (status.includes("success")) {
      message = "Your request to delete a funding account has been processed successfully.";
      this.getFundigAccounts();
    } else {
      message = "Unable to successfully process your request to delete a funding account.";
    }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent,{
      data:{
        title: this.sharedService.getCustomizedTitle('APP_TITLE'),
        message: message,
        buttonText: {
          ok: 'Ok',
          // cancel: 'No'
        }
      }
    });

  }


}
